import { render, staticRenderFns } from "./RegulationList.vue?vue&type=template&id=4347a378&"
import script from "./RegulationList.vue?vue&type=script&lang=js&"
export * from "./RegulationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports